<template>
  <div>
    <app-banner v-if="proposeApp" />

    <default-banner
      v-else-if="showBanner"
      id="banner"
      :text="banner.text"
      :text-mobile="banner.mobile_text"
      :tooltip="banner.tooltip"
      :cookie-key="banner.cookie_key"
      :banner-link="banner.banner_link"
      :expiration-days="banner.expiration_days"
      :aspect="banner.aspect"
    />

    <div class="body__inner" :class="bodyClass">
      <header-default
        v-if="header"
        :header="header"
        :skeleton="loadingConfig"
        :class="{ 'menu-open': isNavOpen, 'cart-open': isCartOpen }"
        @open="openMenu"
      />

      <Nuxt id="main" />

      <footer-default
        v-if="footer"
        :footer="footer"
        :skeleton="loadingConfig"
      />

      <!-- <cookie-banner /> -->

      <cart-menu
        id="cartMenu"
        ref="cartMenu"
        :class="{
          'side-menu--open': isCartOpen,
        }"
        :cgv-link="cgvLink"
      />

      <nav-mobile
        v-if="header"
        :header="header"
        :class="{ 'side-menu--open': isNavOpen }"
        @close="toggleMenu"
      />
    </div>

    <force-connect-modal
      v-if="forceConnect"
      :email="forceConnectEmail"
      :account-status="forceConnectStatus"
      @close="forceConnect = false"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { v4 as uuid } from 'uuid'

import HeaderDefault from '@/components/header/HeaderDefault'
import FooterDefault from '@/components/footer/FooterDefault'
import CartMenu from '@/components/cart/CartMenu'
import NavMobile from '@/components/nav/NavMobile'

import DeliveryMixin from '@/mixins/deliveryText'
import Netlify from '@/mixins/netlify'

import { LS_CART_ID, PRISMIC_CONTEXT, SS_SOURCES, SS_UTMS } from '@/const'
import { EVENTS } from '@/const/events'

import services from '@/services'
import ShopifyBase64 from '@/utils/shopifyBase64'
import sanityService from '~/services/sanityService'

export default {
  name: 'DefaultLayout',
  components: {
    HeaderDefault,
    FooterDefault,
    DefaultBanner: () => ({
      component: import(
        '@/components/banner/DefaultBanner' /* webpackChunkName: 'default_banner' */
      ),
    }),
    // CookieBanner,
    CartMenu,
    NavMobile,
    ForceConnectModal: () => ({
      component: import(
        '@/components/modal/ForceConnect' /* webpackChunkName: 'force_connect_modal' */
      ),
    }),
    AppBanner: () => ({
      component: import(
        '@/components/banner/AppBanner' /* webpackChunkName: 'app_banner' */
      ),
    }),
  },

  mixins: [DeliveryMixin, Netlify],

  data() {
    return {
      siteConfig: null,
      loadingConfig: true,

      banner: {
        text: `Livraison offerte en point relais dès ${process.env.FREE_SHIPPING_PRICE}€`,
        // mobile_text: `Livraison offerte en point relais dès ${process.env.FREE_SHIPPING_PRICE}€`,
        cookie_key: 'free-shipping',
        aspect: 'secondary',
        visible: false,
      },

      isNavOpen: false,
      isCartOpen: false,

      forceConnect: false,
      forceConnectEmail: '',
      forceConnectStatus: '',
      forceConnectLimit: 0,

      cgvLink: '',
      notificationAsked: false,

      proposeApp: false,
      gorgiasIsReady: false,

      touch: {
        down: {
          x: null,
          y: null,
        },
        move: {
          x: null,
          y: null,
        },
      },

      mounted: false,

      CAMPAIGN_FREE_SHIPPING: 'free-shipping',
    }
  },
  async fetch() {
    this.loadingConfig = true

    if (
      this.$parent.context &&
      this.$parent.context.payload &&
      this.$parent.context.payload.siteConfig
    ) {
      this.siteConfig = this.$parent.context.payload.siteConfig
      this.loadingConfig = false
      return
    }

    this.siteConfig = await sanityService.getSiteConfig({
      lang: this.$i18n.locale.slice(0, 2),
    })

    this.loadingConfig = false

    // if (
    //   this.$parent.context &&
    //   this.$parent.context.payload &&
    //   this.$parent.context.payload.header
    // ) {
    //   this.header = this.$parent.context.payload.header
    //   this.loadingHeader = false
    // } else {
    //   const headerDocument = await this.$prismic.client.getSingle('header', {
    //     graphQuery: headerGraphql,
    //     lang: this.$i18n.locale,
    //   })
    //   this.header = headerDocument
    //   this.loadingHeader = false
    // }

    // if (this.header && this.header.data['terms-and-contitions']) {
    //   this.cgvLink = services.linkResolverService.getPathFromLink(
    //     this.header.data['terms-and-contitions']
    //   )
    // }

    // if (
    //   this.$parent.context &&
    //   this.$parent.context.payload &&
    //   this.$parent.context.payload.footer
    // ) {
    //   this.footer = this.$parent.context.payload.footer.data

    //   if (this.$parent.context.payload.highlightedProduct) {
    //     this.highlightedProduct =
    //       this.$parent.context.payload.highlightedProduct
    //   }

    //   if (this.$parent.context.payload.nextHighlightedProduct) {
    //     this.nextHighlightedProduct =
    //       this.$parent.context.payload.nextHighlightedProduct
    //   }

    //   this.loadingFooter = false
    // } else {
    //   const footerDocument = await this.$prismic.client.getSingle('footer', {
    //     lang: this.$i18n.locale,
    //     graphQuery: footerGraphql,
    //   })
    //   this.footer = footerDocument.data
    //   this.loadingFooter = false
    // }

    // if (
    //   this.$parent.context &&
    //   this.$parent.context.payload &&
    //   this.$parent.context.payload.banner
    // ) {
    //   this.banner = this.$parent.context.payload.banner.data
    // } else {
    //   this.getBanner()
    // }
  },
  head() {
    const lang = this.$i18n.locale.substring(0, 2)
    const head = {
      htmlAttrs: {
        lang,
      },
    }
    if (
      process.env.MOBILE_APP_BANNER &&
      process.env.MOBILE_APP_BANNER.includes('ios')
    ) {
      /** PROMPT NATIF IOS */
      head.meta = [
        {
          name: 'apple-itunes-app',
          content: 'app-id=1663813570',
        },
      ]
    }

    return head
  },
  computed: {
    ...mapGetters({
      cart: 'cart/cart',
      countItems: 'cart/countItems',
      customer: 'auth/customer',
      authenticated: 'auth/authenticated',
      connectedEmail: 'subscriptions/connectedEmail',
      visitorId: 'abtest/visitorId',
      campaigns: 'abtest/campaigns',
      isCampaignsLoading: 'abtest/isLoading',
    }),
    bodyClass() {
      const cc = [`body--${this.$i18n.locale.substr(0, 2)}`]

      cc.push(`body--${process.env.SITE_VERSION}`)

      if (this.mounted) {
        cc.push('body__inner--mounted')
      }

      return cc
    },
    showBanner() {
      return this.banner && this.banner.visible
    },
    header() {
      return (
        this.siteConfig &&
        this.siteConfig[`header-${this.$route.params.context}`]
      )
    },
    footer() {
      return (
        this.siteConfig &&
        this.siteConfig[`footer-${this.$route.params.context}`]
      )
    },
  },
  watch: {
    $route(to) {
      if (process.client) {
        this.forceConnectLimit = 0
        this.checkAuthentication(to)

        if (typeof window.ABTastyReload !== 'undefined') {
          window.ABTastyReload()
        }

        if (to.path.includes('/account') && to.path !== '/account/login') {
          this.initGorgias()
          this.$nuxt.$emit('gorgias:show')
        } else {
          this.$nuxt.$emit('gorgias:hide')
        }

        // if (
        //   to.params.context &&
        //   from.params.context &&
        //   to.params.context !== from.params.context
        // ) {
        //   this.$nextTick(() => {
        //     this.getBanner()
        //   })
        // }
      }
    },
    customer() {
      this.$posthogIdentifyCustomer()
    },
    isCampaignsLoading() {
      if (!this.isCampaignsLoading) {
        this.checkShouldShowFreeShipping()
      }
    },
  },
  beforeDestroy() {
    this.$nuxt.$off(EVENTS.SHOW_FORCE_CONNECT)
    this.$nuxt.$off(EVENTS.CLOSE_CART)
    this.$nuxt.$off(EVENTS.ASK_NOTIFICATION)
    this.$nuxt.$off('gorgias:show')
    this.$nuxt.$off('gorgias:hide')
    window.removeEventListener('beforeinstallprompt')
    window.removeEventListener('gorgias-widget-loaded')
  },
  mounted() {
    this.checkAndUpdateDeployId()
    this.checkPreview()

    this.clearBatch()

    const pp = []

    pp.push(this.checkAuthentication())
    pp.push(this.loadCart())
    pp.push(this.loadBisSubscriptions())
    pp.push(this.loadABTestCampaigns())

    Promise.all(pp)
      .then((_) => {
        this.$nuxt.$emit(EVENTS.USER_STATE_LOADED)
      })
      .catch((err) => {
        this.$logError.captureException(err)
      })

    this.$nuxt.$on(EVENTS.SHOW_FORCE_CONNECT, (args) => {
      if (this.forceConnectLimit >= 1) {
        return
      }

      this.forceConnectEmail = args.email
      this.forceConnectStatus = args.status
      this.forceConnect = true
      this.forceConnectLimit++
    })

    this.$nuxt.$on(EVENTS.CLOSE_CART, (_) => {
      this.toggleCart(null, true)
    })

    this.$nuxt.$on(EVENTS.USER_LOGGED_OUT, (_) => {
      this.$track.logout()
    })

    // if (
    //   this.$route.path.includes('/account') &&
    //   this.$route.path !== '/account/login'
    // ) {
    //   this.initGorgias()
    // }

    if (
      process.env.MOBILE_APP_BANNER &&
      process.env.MOBILE_APP_BANNER.includes('android')
    ) {
      this.loadPromptNativeApp()
    }

    this.$track.setLocale(this.$i18n.locale)
    this.$track.context(this.$route.params.context)
    this.$track.event('site_version', {
      version: process.env.SITE_VERSION,
    })

    if (window.optimize && window.optimize.variant) {
      this.$track.optimizeVariant(window.optimize.variant)
    }

    this.handleUTMs()

    if (typeof window.ABTastyReload !== 'undefined') {
      window.ABTastyReload()
    }

    this.mounted = true
  },
  methods: {
    ...mapActions({
      activateTest: 'abtest/activate',
    }),
    ...mapActions({
      getCheckout: 'cart/getCheckout',
      updateCartItemDelivery: 'cart/updateCartItemDelivery',
      addCartAttribute: 'cart/addAttribute',
      updateUpsell: 'cart/updateUpsell',
      updateUpsellItems: 'cart/updateUpsellItems',
      removeUnvailableItems: 'cart/removeUnvailableItems',
      hasConnectedEmail: 'subscriptions/hasConnectedEmail',
      getUserSubscriptions: 'subscriptions/getUserSubscriptions',
      initAuthentication: 'auth/initAuthentication',
      hasVisitorId: 'abtest/hasVisitorId',
      setVisitorId: 'abtest/setVisitorId',
      getCampaigns: 'abtest/getCampaigns',
    }),

    checkPreview() {
      const query = this.$route.query
      if (query['sanity-preview-perspective']) {
        services.sanityService.activatePreview(
          query['sanity-preview-perspective'],
          query['sanity-preview-secret']
        )
        this.$nuxt.refresh()
      }
    },

    loadPromptNativeApp() {
      window.addEventListener('beforeinstallprompt', (e) => {
        // Prevent Chrome 67 and earlier from automatically showing the prompt
        e.preventDefault()
        this.proposeApp = true
      })
    },

    checkShouldShowFreeShipping() {
      if (
        this.$i18n.locale.slice(0, 2) === 'fr' &&
        this.campaigns.hasCampaignByName(this.CAMPAIGN_FREE_SHIPPING)
      ) {
        const campaign = this.campaigns.getCampaignByName(
          this.CAMPAIGN_FREE_SHIPPING
        )

        if (campaign.variation?.name === 'Variation') {
          this.banner.visible = true
        }

        this.activateTest({
          campaignName: campaign.campaignName,
          variationId: campaign.variation.id,
          variationName: campaign.variation.name,
          variationGroupId: campaign.variationGroupId,
        })
      }
    },

    async loadCart() {
      const checkoutID = localStorage.getItem(LS_CART_ID)

      if (checkoutID) {
        await this.getCheckout(checkoutID)

        if (this.countItems > 0) {
          this.refreshProductsDelivery()
        }
      }
    },
    async loadBisSubscriptions() {
      await this.hasConnectedEmail().then((exists) => {
        if (exists) {
          return this.getUserSubscriptions(this.connectedEmail)
        }
      })
    },
    async loadABTestCampaigns() {
      await this.hasVisitorId()
        .then(async (exists) => {
          try {
            if (!exists) {
              // TODO récupérer ça d'ailleurs
              await this.setVisitorId(uuid())
            }

            await this.getCampaigns(this.visitorId)
          } catch (err) {
            this.$logError.captureException(err)
          }
        })
        .catch((err) => {
          this.$logError.captureException(err)
        })
    },
    async checkAuthentication(to) {
      if (this.authenticated === null) {
        try {
          await this.initAuthentication()
        } catch (err) {
          this.$logError.captureException(err)
        }
      }

      if (this.authenticated) {
        if (!to) {
          this.$logError.identify(this.customer)
          this.$track.setUser(this.customer)
        }
      } else if (
        this.$route.path.includes('/account') ||
        to?.path.includes('/account')
      ) {
        if (
          this.$route.path.includes('/account/login') ||
          this.$route.path.includes('reset-password')
        ) {
          return
        }

        return this.$router.push(
          this.$contextPath(
            '/account/login?return_url=' +
              encodeURI(to ? to.path : this.$route.path)
          )
        )
      }
    },

    /**
     * AB Test Free Shipping : Banner
     */
    // async getBanner() {
    //   try {
    //     const bannerDocument = await this.$prismic.client.getByUID(
    //       'banniere',
    //       `banner-${this.$route.params.context}`,
    //       {
    //         lang: this.$i18n.locale,
    //       }
    //     )

    //     this.banner = bannerDocument.data
    //   } catch (err) {
    //     if (!err.message.includes('No documents were returned')) {
    //       this.$logError.captureException(err)
    //     }
    //   }
    // },

    getTouches(evt) {
      return (
        evt.touches || // browser API
        evt.originalEvent.touches
      )
    },
    handleTouchStart(evt) {
      const touch = this.getTouches(evt)[0]
      this.touch.down.x = touch.clientX
      this.touch.down.y = touch.clientY

      document.addEventListener('touchmove', this.handleTouchMove)
    },
    handleTouchMove(evt) {
      const touch = this.getTouches(evt)[0]
      this.touch.move.x = touch.clientX
      this.touch.move.y = touch.clientY
    },
    handleTouchEnd(ev) {
      document.removeEventListener('touchmove', this.handleTouchMove)

      const xDiff = this.touch.move.x - this.touch.down.x
      const yDiff = this.touch.move.y - this.touch.down.y

      const hasSwipeLeft = xDiff > 50 && Math.abs(yDiff) < 50

      if (hasSwipeLeft) {
        if (this.isNavOpen) {
          this.toggleMenu(ev)
        }

        if (this.isCartOpen) {
          this.toggleCart(ev)
        }
      }
    },
    clickBody(ev) {
      if (this.isNavOpen) {
        const nav = document.getElementById('navMenu')

        if (!nav.contains(ev.target)) {
          this.toggleMenu(ev)
        }
      }

      if (this.isCartOpen) {
        const cart = document.getElementById('cartMenu')

        if (cart && !cart.contains(ev.target)) {
          this.toggleCart(ev)
        }
      }
    },

    openMenu(type, ev) {
      if (type === 'cart') {
        return this.toggleCart(ev)
      }

      return this.toggleMenu(ev)
    },

    async toggleMenu(ev) {
      ev && ev.stopPropagation()

      const main = document.getElementById('main')

      if (this.isNavOpen) {
        main.classList.remove('menu-open')
        document.body.style.overflow = ''
        document.documentElement.style.overflow = ''
        document.body.removeEventListener('click', this.clickBody)
        document.removeEventListener('touchstart', this.handleTouchStart)
        document.removeEventListener('touchend', this.handleTouchEnd)
        this.isNavOpen = false
      } else {
        document.body.style.overflow = 'hidden'
        document.documentElement.style.overflow = 'hidden'

        document.body.addEventListener('click', this.clickBody)
        document.addEventListener('touchstart', this.handleTouchStart)
        document.addEventListener('touchend', this.handleTouchEnd)

        const { gsap } = await import('gsap' /* webpackChunkName: 'gsap' */)

        const menu = document.getElementById('navMenu')
        const children = menu.getElementsByClassName('nav-mobile__to-animate')

        for (const child of children) {
          child.classList.add('no-animate')
        }

        main.classList.add('menu-open')
        menu.classList.add('no-animate')

        const tl = gsap.timeline({
          onComplete: () => {
            this.isNavOpen = true
            menu.style = ''
            menu.classList.remove('no-animate')

            for (const child of children) {
              child.classList.remove('no-animate')
            }
          },
        })

        tl.to(menu, {
          right: 0,
          duration: 0.2,
          ease: 'ease.in',
        })

        tl.from(children, {
          opacity: 0,
          y: -20,
          duration: 0.3,
          stagger: {
            amount: 0.3,
            ease: 'power1.out',
          },
          ease: 'back.out(1.7)',
        })

        this.$track.event('menu-open')
      }

      return false
    },
    toggleCart(ev, close = null) {
      ev && ev.stopPropagation()

      const main = document.getElementById('main')

      if (this.isCartOpen || (close !== null && close)) {
        main.classList.remove('cart-open')
        document.body.style.overflow = ''
        document.documentElement.style.overflow = ''
        document.body.removeEventListener('click', this.clickBody)
        document.removeEventListener('touchstart', this.handleTouchStart)
        document.removeEventListener('touchend', this.handleTouchEnd)
        this.isCartOpen = false
      } else {
        main.classList.add('cart-open')
        document.body.style.overflow = 'hidden'
        document.documentElement.style.overflow = 'hidden'

        document.body.addEventListener('click', this.clickBody)
        document.addEventListener('touchstart', this.handleTouchStart)
        document.addEventListener('touchend', this.handleTouchEnd)

        this.updateUpsellItems()

        if (
          this.cart &&
          !this.cart.attributes.some(
            (a) => a.key === 'locale' && a.value === this.$i18n.locale
          ) &&
          !this.cart.attributes.some(
            (a) =>
              a.key === 'context' &&
              a.value === PRISMIC_CONTEXT[this.$route.params.context]
          )
        ) {
          this.addCartAttribute([
            {
              key: 'locale',
              value: this.$i18n.locale,
            },
            {
              value: PRISMIC_CONTEXT[this.$route.params.context],
              key: 'context',
            },
          ]).catch((err) => {
            this.$logError.captureException(err)
          })
        }

        // AB Test Free Shipping
        // const KEY_FREE_SHIPPING = '_abtest-free-shipping'
        // if (
        //   this.cart &&
        //   this.$i18n.locale.slice(0, 2) === 'fr' &&
        //   this.campaigns.hasCampaignByName(this.CAMPAIGN_FREE_SHIPPING) &&
        //   !this.cart.attributes.find(
        //     (a) =>
        //       a.key === KEY_FREE_SHIPPING &&
        //       a.value ===
        //         this.campaigns.getCampaignByName(this.CAMPAIGN_FREE_SHIPPING)
        //           ?.variation?.name
        //   )
        // ) {
        //   this.addCartAttribute({
        //     key: KEY_FREE_SHIPPING,
        //     value: this.campaigns
        //       .getCampaignByName(this.CAMPAIGN_FREE_SHIPPING)
        //       ?.variation?.name.toLowerCase(),
        //   }).catch((err) => {
        //     this.$logError.captureException(err)
        //   })
        // }

        this.$track.event('cart-open')

        if (this.countItems > 0) {
          this.removeUnvailableItems()
          this.refreshProductsDelivery()
          this.$refs.cartMenu.updateUpsellingBlock()
          this.$track.hasSeenExperiment('psp-in-cart')
        }

        this.isCartOpen = true
      }

      return false
    },

    async refreshProductsDelivery() {
      const productsWithMetafieldDelivery =
        await services.productService.getShopifyProductsMetafieldDelivery(
          [
            ...new Set(
              this.cart?.lines.edges.map((e) =>
                ShopifyBase64.getId(e.node.merchandise.product.id)
              )
            ),
          ],
          this.$i18n.locale
        )

      this.updateCartItemDelivery({
        products: productsWithMetafieldDelivery,
        getDeliveryText: (d) => {
          const deliveryText = this.getDeliveryFromDate(d)
          return this.$t(deliveryText.ref, deliveryText.options)
        },
      })
    },

    initGorgias() {
      if (document.getElementById('gorgias-chat-widget-install')) {
        return false
      }
      const locale = this.$i18n.locales.find((locale) => {
        return locale.code === this.$i18n.locale
      })
      const c = this.$route.params.context
      const gorgiasIDs = locale.gorgias

      if (!gorgiasIDs || !gorgiasIDs[c]) {
        return false
      }

      window.addEventListener('gorgias-widget-loaded', () => {
        this.gorgiasIsReady = true

        this.$nuxt.$on('gorgias:show', () => {
          if (this.gorgiasIsReady && window.GorgiasChat) {
            const chatElem = document.getElementById('gorgias-chat-container')
            chatElem.style.display = ''
          }
        })

        this.$nuxt.$on('gorgias:hide', () => {
          if (this.gorgiasIsReady && window.GorgiasChat) {
            const chatElem = document.getElementById('gorgias-chat-container')
            chatElem.style.display = 'none'
          }
        })
      })

      const gorgiasID = gorgiasIDs[c]

      const t = document.getElementsByTagName('script')[0]
      const s = document.createElement('script')
      s.async = true
      s.id = 'gorgias-chat-widget-install'
      s.src = `https://config.gorgias.chat/bundle-loader/${gorgiasID}`
      s.type = 'text/javascript'
      t.parentNode.insertBefore(s, t)
    },

    clearBatch() {
      if (navigator.serviceWorker) {
        navigator.serviceWorker
          .getRegistrations()
          .then((registrations) => {
            registrations.forEach((registration) => {
              if (
                registration.active &&
                registration.active.scriptURL.includes(
                  'batchsdk-worker-loader.js'
                )
              ) {
                registration.unregister()
              }
            })
          })
          .catch(() => {
            this.$logError.captureException(
              new Error('Error while unregistering batch service worker')
            )
          })
      }
    },

    handleUTMs() {
      const utms = {}
      const sources = {}

      for (const key of Object.keys(this.$route.query)) {
        if (key.startsWith('utm_')) {
          utms[key] = this.$route.query[key]
        } else if (key.startsWith('source_')) {
          sources[key] = this.$route.query[key]
        }
      }

      if (Object.keys(utms).length > 0) {
        window.sessionStorage.setItem(SS_UTMS, JSON.stringify(utms))
      }

      if (Object.keys(sources).length > 0) {
        window.sessionStorage.setItem(SS_SOURCES, JSON.stringify(sources))
      }
    },
  },
}
</script>

<style lang="scss">
.body__inner {
  position: relative;
}

#main {
  transition: all 0.4s cubic-bezier(0.46, 0.01, 0.32, 1);

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    pointer-events: none;
    z-index: 2001;
    transition: all 0.3s;
  }

  &.menu-open,
  &.cart-open {
    &::before {
      background: rgba($primary-color, 0.5);
      pointer-events: all;
    }
  }
}

.side-menu {
  position: fixed;
  max-width: 95%;
  overflow: hidden auto;
  top: 0;
  bottom: 0;
  z-index: 2005;
  transition: all 0.4s cubic-bezier(0.46, 0.01, 0.32, 1);
}
</style>
